define('glu/grid/paginate/viewingDetails',['require','../../itemView','hbs!./viewingDetails.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        tmpl = require('hbs!./viewingDetails.hbs');

    return ItemView.extend({
        template: tmpl,

        templateHelpers: function() {
            return this.options.data;
        }
    });
});

